module.exports = __webpack_public_path__ + "img/android_logo_preview.28399fc0.png";